var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.locationkey == 'thwi')?_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.$config.graphpath + 'logo_thwi_sm.png',"alt":"","title":"TH Wildau"}})]):_c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":_vm.$config.graphpath + 'logo_btu_sm.png',"alt":"","title":"BTU Cottbus-Senftenberg"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }